export default {"src":"/_next/static/media/888sport.4ea687b8.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};